export default __webpack_public_path__ + "static/media/17.083304d1.png";